import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { loadAction, loadFailAction, loadSuccessAction } from './user-notifications.actions';
import { UserNotificationsService } from './user-notifications.service';

export const loading = createEffect(
  (actions$ = inject(Actions), userNotificationsService = inject(UserNotificationsService)) => {
    return actions$.pipe(
      ofType(loadAction),
      switchMap(() =>
        userNotificationsService.getNotifications().pipe(
          map(response => loadSuccessAction(response.response)),
          catchError(() => of(loadFailAction()))
        )
      )
    );
  },
  { functional: true }
);
